import React from "react";
import { useNavigate } from "react-router";
import moment from "moment";
import subdirectoryArrowRightIcon from "../../assets/images/subdirectory-arrow-right.svg";
import { useUserContext } from "../../context/UserContext";

const PatientResultsList = ({ 
  searchPatientList, 
  patientSearchLoad,
  onPatientSelect 
}) => {
  const { userData } = useUserContext();
  const navigate = useNavigate();

  const handlePatientClick = (item) => {
    if (userData?.users?.type === "Doctor") {
      if (item?.relation && item?.parent_details) {
        navigate(`/doctor/patient-dictionary/${item?.parent_id}?child=${item?.id}`);
      } else {
        navigate(`/doctor/patient-dictionary/${item?.id}`);
      }
    } else if (userData?.users?.type === "Nurse") {
      navigate(`/nurse/patient-dictionary/${item?.id}`);
    }
    
    if (onPatientSelect) {
      onPatientSelect();
    }
  };

  return (
    <div className="patients-results-list">
      {(!searchPatientList || searchPatientList.length === 0) && !patientSearchLoad && (
        <div className="no-results">No patient found</div>
      )}
      
      {searchPatientList?.map((item, index) => {
        const isLocal = item?.is_local || item?.profile_type === 'local';
        const isKid = item?.is_kid === true || item?.is_child === true || (item?.relation && item?.parent_id > 0);
        
        const maskIdNumber = (idNum) => {
          if (!idNum) return "";
          const idStr = idNum.toString();
          if (idStr.length < 6) return idStr;
          return `${idStr.substring(0, 4)}**${idStr.substring(idStr.length - 2)}`;
        };
        
        const maskedId = item?.id_number ? maskIdNumber(item.id_number) : '';

        const apptCount = Number(item?.appointment_count_with_doctor ?? item?.previous_appointments_count ?? 0);
        const alreadyVisited = item?.already_visited == true || item?.already_visited === 1
          || item?.is_my_patient == true
          || apptCount > 0;

        const wilaya = item?.wilaya || item?.city || 'Guelma';
        const commune = item?.commune || 'Hiliopolis';
        const address = `${wilaya}, ${commune}`;
        
        const parentName = item?.parent_name || 
          (item?.parent_details?.[0] ? 
            `${item.parent_details[0].first_name} ${item.parent_details[0].last_name}` : 
            '');
        const parentId = item?.parent_details?.[0]?.id_number || '';
        const maskedParentId = parentId ? maskIdNumber(parentId) : '';

        return (
          <div
            className={`patient-result-item ${isLocal ? 'local-profile' : 'national-profile'}`}
            key={index}
            onClick={() => handlePatientClick(item)}
            style={{ position: 'relative' }}
          >
            {alreadyVisited && (
              <span style={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                background: '#e6f9f0',
                color: '#1a9e5c',
                border: '1px solid #1a9e5c',
                borderRadius: '12px',
                padding: '2px 8px',
                fontSize: '11px',
                fontWeight: '600',
                whiteSpace: 'nowrap',
                zIndex: 1
              }}>✔ Déjà venu(e)</span>
            )}
            <div className="patient-avatar">
              {((item?.first_name || '').charAt(0) + (item?.last_name || '').charAt(0)).toUpperCase()}
            </div>
            <div className="patient-info">
              <div className="patient-name">
                {item?.first_name} {item?.last_name}
                {item?.gender && <span className="gender-badge">{item.gender}</span>}
                {item?.dob && (
                  <span className="dob-text">
                    {moment(item.dob).format("DD/MM/YYYY")}
                    {item?.age && ` (${item.age})`}
                  </span>
                )}
                {isKid && <span className="kid-icon">👶</span>}
              </div>
              <div className="patient-details">
                <span className="profile-type-badge">{isLocal ? 'Local' : 'National'}</span>
                {address && <span>{address}</span>}
                {item?.cell_phone && <span>{item.cell_phone}</span>}
                {!isKid && maskedId && <span>ID: {maskedId}</span>}
              </div>
              {isKid && (parentName || maskedParentId) && (
                <div className="parent-info">
                  <img src={subdirectoryArrowRightIcon} alt="→" className="arrow-icon" />
                  <span>
                    {parentName}
                    {maskedParentId && ` • ID: ${maskedParentId}`}
                  </span>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PatientResultsList;
